import Recat, { Component } from "react";
import { connect } from "react-redux";
import { XIcon } from "@heroicons/react/outline";
import _ from "lodash";
import LocaleStrings from "../../../languages/index";
import AboutCustomer from "./tabs/abouttab/aboutcustomer";
import WatchList from "./tabs/watchlistab/watchlist";
import WishList from "./tabs/wishlisttab/wishlist";
import OdersList from "./tabs/oders/oderslist";
import AuctionList from "./tabs/auction/auctions";
import NegotiationList from "./tabs/negotiation/negotiations";
import TransactionList from "./tabs/trasactions/transaction";
import { newtabs } from "../actions/index";
import toast, { Toaster } from "react-hot-toast";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

class Customertabs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabIndextoShow: 1,
    };
  }

  componentDidMount() {}

  componentDidUpdate() {}

  closetabs() {
    this.props.newtabs();
  }

  // On Tabs change
  onTabsChange = (e, tabindex, callfrom) => {
    if (callfrom === "lg") {
      // For tabs
      this.setState({ tabIndextoShow: parseInt(tabindex) });
    } else {
      // For Select box
      this.setState({ tabIndextoShow: parseInt(e.target.value) });
    }
  };

  render() {
    var selectedTab = "";
    return (
      <>
        <div className="text-xl text-ternary pl-8">
          {_.startCase(this.props.customerlistingtabs.username)}
        </div>

        <div className="pt-3 px-3">
          {/* Header Part */}
          <button
            type="button"
            className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-custWhite bg-black hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ternary"
            onClick={(e) => this.closetabs()}>
            <XIcon className="h-5 w-5" aria-hidden="true" />
          </button>
          <span className="px-2  items-center">
            {LocaleStrings.customer_management}
          </span>
        </div>
        <div className="py-3 px-6">
          {/* Form Tabs */}
          <div>
            <div className="lg:hidden">
              <label htmlFor="tabs" className="sr-only">
                Select a tab
              </label>
              <select
                id="tabs"
                name="tabs"
                className="block w-full focus:ring-primary focus:border-primary border-ternary rounded-md"
                defaultValue={this.props.tabs.find((tab) => tab.current).name}
                onChange={(e) => this.onTabsChange(e, 0, "sm")}>
                {this.props.tabs.map((tab) => (
                  <option
                    key={tab.name}
                    value={tab.tabindex}
                    selected={
                      this.state.tabIndextoShow === tab.tabindex
                        ? "selected"
                        : ""
                    }>
                    {tab.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="hidden lg:block">
              <nav className="relative z-0 rounded-lg flex  " aria-label="Tabs">
                {this.props.tabs.map((tab, tabIdx) => (
                  <span
                    style={{ marginRight: "20px", borderRadius: "6px" }}
                    key={tab.name}
                    className={classNames(
                      this.state.tabIndextoShow === tab.tabindex
                        ? "text-secondary"
                        : "text-ternary hover:text-secondary",
                      tabIdx === 0 ? "rounded-l-lg" : "",
                      tabIdx === this.props.tabs.length - 1
                        ? "rounded-r-lg"
                        : "",
                      "cursor-pointer group relative min-w-0 flex-1 overflow-hidden bg-custWhite py-4 px-4 text-xs font-normal text-center hover:bg-quaternary focus:z-10 "
                    )}
                    aria-current={
                      this.state.tabIndextoShow === tab.tabindex
                        ? "page"
                        : undefined
                    }
                    onClick={(e) => this.onTabsChange(e, tab.tabindex, "lg")}>
                    <span>{tab.name}</span>
                    <span
                      aria-hidden="true"
                      className={classNames(
                        this.state.tabIndextoShow === tab.tabindex
                          ? "bg-primary"
                          : "bg-transparent",
                        "absolute inset-x-0 bottom-0 h-0.5"
                      )}
                    />
                  </span>
                ))}
              </nav>
            </div>
            <div className="">
              <div className="">
                {/* <form className=""> */}
                <div
                  className={this.state.tabIndextoShow === 1 ? "" : "hidden"}>
                  <AboutCustomer data={this.props.customerlistingtabs} />
                </div>
                <div
                  className={this.state.tabIndextoShow === 2 ? "" : "hidden"}>
                  <WatchList data={this.props.customerlistingtabs} />
                </div>
                <div
                  className={this.state.tabIndextoShow === 3 ? "" : "hidden"}>
                  <WishList data={this.props.customerlistingtabs} />
                </div>
                <div
                  className={this.state.tabIndextoShow === 4 ? "" : "hidden"}>
                  <OdersList data={this.props.customerlistingtabs} />
                </div>
                <div
                  className={this.state.tabIndextoShow === 5 ? "" : "hidden"}>
                  <AuctionList data={this.props.customerlistingtabs} />
                </div>
                <div
                  className={this.state.tabIndextoShow === 6 ? "" : "hidden"}>
                  <NegotiationList data={this.props.customerlistingtabs} />
                </div>
                <div
                  className={this.state.tabIndextoShow === 7 ? "" : "hidden"}>
                  <TransactionList data={this.props.customerlistingtabs} />
                </div>

                {/* </form> */}
              </div>
            </div>
          </div>
        </div>
        <Toaster />
      </>
    );
  }
}

function mapStateToProps(state, ownProps) {
  var { session, user } = state;
  // console.log('customerlistingtabs',state.customerlistingtabs);
  return {
    session,
    user,
    isLoggedIn: state.isLoggedIn,
    sidebarSelectedMenu: state.sidebarSelectedMenu,
    language: state.language,
    tabs: state.customermanagementTabs,
    customerlistingtabs: state.customerlistingtabs,
    newtablist: state.newtablist,
  };
}

export default connect(mapStateToProps, { newtabs })(Customertabs);
